import { useEffect } from 'react'
import { useBfnStore } from '@/store/useBfnStore'
import { addDays, differenceInDays, differenceInMilliseconds } from 'date-fns'
import { Befehlsnachricht } from '@/models/Befehlsnachricht'
import { useShallow } from 'zustand/react/shallow'

const isOlderThan366Days = (befehlsnachricht: Befehlsnachricht) =>
  differenceInDays(new Date(), befehlsnachricht.versandzeitpunkt) >= 366

export const useBefehlsnachrichtenCleanup = () => {
  const [data, removeData] = useBfnStore(
    useShallow((state) => [state.data, state.removeData])
  )

  useEffect(() => {
    const cleanupOldBfns = () => {
      for (const [id, entry] of Object.entries(data)) {
        if (isOlderThan366Days(entry.befehlsnachricht)) {
          removeData(id)
        }
      }
    }

    const scheduleNextCleanup = () => {
      const bfns = Object.entries(data).map(
        ([, entry]) => entry.befehlsnachricht
      )
      if (bfns.length > 0) {
        const oldestBfn = bfns.toSorted((a, b) =>
          differenceInMilliseconds(a.versandzeitpunkt, b.versandzeitpunkt)
        )[0]
        const nextCleanupDate = addDays(oldestBfn.versandzeitpunkt, 366)
        if (nextCleanupDate) {
          const timeout = setTimeout(cleanupOldBfns, nextCleanupDate.getTime())
          return () => clearTimeout(timeout)
        }
      }
    }

    cleanupOldBfns()
    scheduleNextCleanup()
  }, [data, removeData])
}
